import {useMutation, useQueryClient} from '@tanstack/react-query';
import {fundraisersApi} from '../api';
import {CreateFundraiserNotificationDTO} from '../model';
import {useNotifications} from '../../../shared';

export const useSendFundraiserCommunicationMessage = (appealId: string) => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const sendMessageMutation = useMutation({
    mutationFn: (dto: CreateFundraiserNotificationDTO) => fundraisersApi.sendCommunicationMessage(appealId, dto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['fundraiser-communication', appealId],
        refetchType: 'all',
      });
      createNotification({
        title: 'Уведомление отправлено',
        name: 'sendCommunicationMessage',
        theme: 'success',
      });
    },
  });

  return {
    sendMessageMutation,
  };
};
